import { render, staticRenderFns } from "./crm-transaction.vue?vue&type=template&id=e4860adc&"
import script from "./crm-transaction.vue?vue&type=script&lang=js&"
export * from "./crm-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports